<template>
  <span class="p-input-icon-left" v-if="isFiltered">
    <i class="pi pi-search" style="font-size: 0.8rem!important;" />
    <InputText
      style="font-size: 0.9rem!important;"
      placeholder="Search"
      @input="search(item)"
      v-model="value"
    />
  </span>
</template>

<script>
import InputText from "primevue/inputtext";

export default {
  name: "SearchInputCustom",
  components: {
    InputText
  },
  props: {
    isFiltered: Boolean,
    item: Object
  },
  data() {
    return {
      value: ""
    };
  },
  methods: {
    search(item) {
      setTimeout(() => {
        item.filteredChildren = item.children.filter(child => {
          return child[item.nameData]
            .toLowerCase()
            .includes(this.value.toLowerCase());
        });
      }, 250);
    }
  }
};
</script>
